module.exports = __webpack_public_path__ + "static/media/12575949_10205540438890223_1156670554_n.02577678.jpg";